





























import SectionTitle from '@/components/SectionTitle.vue'
import Vue from 'vue'
interface iData{
  honor: any[]
}
const CoreHead = Vue.extend({
  components: {
    SectionTitle
  },
  data (): iData {
    return {
      honor: [
        {
          name: '资质认证',
          active: true,
          imgs: [
            require('@/assets/image/about/honor/h1-1.png'),
            require('@/assets/image/about/honor/h1-2.png'),
            require('@/assets/image/about/honor/h1-3.jpg'),
            require('@/assets/image/about/honor/h1-4.jpg')
          ]
        },
        {
          name: '软著',
          active: false,
          imgs: [
            require('@/assets/image/about/honor/h2-1.png'),
            require('@/assets/image/about/honor/h2-2.png'),
            require('@/assets/image/about/honor/h2-3.png'),
            require('@/assets/image/about/honor/h2-4.jpg'),
            require('@/assets/image/about/honor/h2-5.jpg'),
            require('@/assets/image/about/honor/h2-6.jpg'),
            require('@/assets/image/about/honor/h2-7.jpg')
          ]
        },
        {
          name: '质量认证',
          active: false,
          imgs: [
            require('@/assets/image/about/honor/h3-1.png'),
            require('@/assets/image/about/honor/h3-2.png')
          ]
        },
        {
          name: '其他荣誉',
          active: false,
          imgs: [
            require('@/assets/image/about/honor/h4-1.png'),
            require('@/assets/image/about/honor/h4-2.png'),
            require('@/assets/image/about/honor/h4-3.jpg'),
            require('@/assets/image/about/honor/h4-4.jpg'),
            require('@/assets/image/about/honor/h4-5.jpg')

          ]
        }
      ]
    }
  },
  methods: {
    changeActive (index: number) {
      this.honor.forEach((item, inx) => {
        item.active = false
        if (inx === index) item.active = true
      })
    }
  }
})
export default CoreHead
